
const CardDetailModal = () => import('../_components/_shared/CardDetailModal.vue')
const TransactionEditModal = () => import('@/modules/transactions/_components/_shared/TransactionsEditModal.vue')

export default {
  data () {
    return {
      showCardDetailModalFlag: false,
      showTransactionEditModalFlag: false,
      showTransactionReceiptModalFlag: false,
      cardId: 0,
      transactionToEditId: 0

    }
  },
  components: {
    CardDetailModal,
    TransactionEditModal

  },
  methods: {
    showDownloadModal (filters) {
      this.$emit('showDownloadModal', filters)
    },
    showCardDetailModal (event) {
      this.cardId = event

      this.showCardDetailModalFlag = true
    },
    showTransactionDetail (event) {
      this.transactionToEditId = event
      this.showTransactionEditModalFlag = true
    },
    handleCloseReceipts () {
      if (this.showTransactionReceiptModalFlag) {
        this.showTransactionReceiptModalFlag = false
        this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
      }
    },

    async toggleCardStatus (card) {
      if (card.cardStatus === 'ACTIVE') {
      await this.$store.dispatch('CardsStore/freezeCard', {
          cardId: card.cardId,
          cardInfo: card.cardInfo
        })
      } else if (card.cardStatus === 'FROZEN') {
        await this.$store.dispatch('CardsStore/activateCard', {
          cardId: card.cardId,
          cardInfo: card.cardInfo

        })
      }
    }

  }

}
